import { render, staticRenderFns } from "./ArenaVehicleTypeForm.vue?vue&type=template&id=42865ce0"
import script from "./ArenaVehicleTypeForm.vue?vue&type=script&lang=js"
export * from "./ArenaVehicleTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports